import ApprentiNom from '@/generated/controls/apprenti/ApprentiNom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ApprentiNom
})
